import { render, staticRenderFns } from "./FloatingBallToolPanel.vue?vue&type=template&id=228ff2e0&scoped=true"
import script from "./FloatingBallToolPanel.vue?vue&type=script&lang=js"
export * from "./FloatingBallToolPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatingBallToolPanel.vue?vue&type=style&index=0&id=228ff2e0&prod&lang=less"
import style1 from "./FloatingBallToolPanel.vue?vue&type=style&index=1&id=228ff2e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ff2e0",
  null
  
)

export default component.exports